<template>
  <div class="space-y-4">
    <Loading v-if="loading" />
    <div class="flex justify-end">
      <BaseButton @click="onCreate">Tambah</BaseButton>
    </div>
    <Datatable
      :columns="tableColumns"
      :total="orderRoutes.meta.page.total"
      :perPage="orderRoutes.meta.page.perPage"
      :currentPage="orderRoutes.meta.page.currentPage"
      @pagechanged="onChangePage"
    >
      <template #tbody="{ classes }">
        <tr
          v-for="orderRoute in orderRoutes.data"
          :key="orderRoute.id"
          :class="classes.tr"
        >
          <td :class="classes.td">
            {{ orderRoute.attributes.origin_office_code }}
          </td>
          <td :class="classes.td">
            {{ orderRoute.attributes.destination_office_code }}
          </td>
          <td :class="classes.td">
            {{
              orderRoute.attributes.shipment_type === 'pickup'
                ? 'Diambil'
                : 'Dikirim'
            }}
          </td>
          <td :class="classes.td">{{ orderRoute.attributes.area_name }}</td>
          <td :class="classes.td">
            <div class="flex gap-1">
              <BaseButton for-icon @click="onEdit(orderRoute)">
                <Icon
                  icon="heroicons:pencil-square-solid"
                  class="text-green-600"
                />
              </BaseButton>
              <BaseButton for-icon color="danger" @click="onDelete(orderRoute)">
                <Icon icon="heroicons:trash-solid" class="text-red-600" />
              </BaseButton>
            </div>
          </td>
        </tr>
      </template>
    </Datatable>
    <OrderRouteFormModal
      :destination-office-type="destinationOfficeType"
      :visible="formModal.visible"
      :id="formModal.id"
      @close="formModal.visible = false"
      @saved="loadOrderRoutes"
    />
    <OrderRouteDeleteConfirm
      :visible="deleteConfirm.visible"
      :id="deleteConfirm.id"
      @close="deleteConfirm.visible = false"
      @deleted="loadOrderRoutes"
    />
  </div>
</template>

<script>
import { requestMixin } from '../../../mixins/request/request';
import OrderRouteDeleteConfirm from './SetupKebijakanWilayahHarga/OrderRouteDeleteConfirm.vue';
import OrderRouteFormModal from './SetupKebijakanWilayahHarga/OrderRouteFormModal.vue';

export default {
  mixins: [requestMixin],
  components: { OrderRouteFormModal, OrderRouteDeleteConfirm },
  props: {
    destinationOfficeType: String
  },
  data() {
    return {
      formModal: {
        id: null,
        visible: false,
      },
      deleteConfirm: {
        id: null,
        visible: false,
      },
      loading: false,
      orderRoutes: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    tableColumns() {
      return [
        { id: 'origin_office', name: 'Kantor Tujuan' },
        { id: 'destination_office', name: 'Kantor Destinasi' },
        { id: 'shipment_type', name: 'Metode Pengiriman' },
        { id: 'area', name: 'Area' },
        { id: 'action', name: 'Aksi' },
      ];
    },
  },
  methods: {
    async loadOrderRoutes(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/order-routes`, {
        params: {
          'fields[order-routes]':
            'shipment_type,origin_office_code,destination_office_code,area_name',
          sort: '-id',
          'page[size]': 5,
          'filter[destination_office_type]': this.destinationOfficeType,
          ...params,
        },
      });

      if (!err) {
        this.orderRoutes = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadOrderRoutes({
        'page[number]': page,
      });
    },
    onCreate() {
      this.formModal.id = null;
      this.formModal.visible = true;
    },
    onEdit(orderRoute) {
      this.formModal.id = orderRoute.id;
      this.formModal.visible = true;
    },
    onDelete(orderRoute) {
      this.deleteConfirm.id = orderRoute.id;
      this.deleteConfirm.visible = true;
    },
  },
  created() {
    this.loadOrderRoutes();
  },
};
</script>
